import React from 'react';
import { Text } from 'rsuite';
import '../../css/tables.css';

export interface SummaryRow {
  label: string;
  value: string;
  bold?: boolean;
}

interface TableComponentProps {
  data: SummaryRow[];
  title?: string;
}

export const TableComponent: React.FC<TableComponentProps> = ({
  data,
  title,
}) => {
  return (
    <div>
      {title && (
        <Text
          as="h4"
          style={{ marginBottom: 8 }}
        >
          {title}
        </Text>
      )}
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <tbody>
          {data.map((rowData, index) => (
            <tr
              key={`index-${rowData.label}`}
              style={{
                background:
                  index % 2 === 0 ? 'var(--ds-gray-50)' : 'var(--white)',
                padding: '6px 4px',
                fontWeight: rowData.bold ? 700 : 400,
                fontSize: '14px',
              }}
            >
              <th
                scope="row"
                style={{
                  padding: '6px 4px',
                  fontWeight: 'inherit',
                  textAlign: 'left',
                }}
              >
                <Text>{rowData.label}</Text>
              </th>
              <td style={{ padding: '6px 4px', textAlign: 'right' }}>
                <Text>{rowData.value}</Text>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
